import type { TokenWithUnit } from '@pba/react-theme';

declare module '@pba/react-theme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type -- Bug in linter
  interface CustomThemeConfig extends WebCustomThemeConfig {}
}

export interface WebCustomThemeConfig {
  web: {
    layout: {
      header: {
        height: TokenWithUnit;
      };
      widget: {
        height: {
          min: TokenWithUnit;
        };
      };
    };
  };
}

export const webCustomThemeConfig: WebCustomThemeConfig = {
  web: {
    layout: {
      header: {
        height: { unit: 'px', value: 64 },
      },
      widget: {
        height: {
          min: { unit: 'px', value: 72 },
        },
      },
    },
  },
};
